import React from "react";
import type { FC } from "react";

import { createDisplayNameForCoreInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForCoreInputTextElement } from "../../utils/getTestId";

import type { InputTextLeftAddonProps } from "../../types";

import classes from "./CoreInputTextLeftAddon.styl";

const INPUT_TEXT_LEFT_ADDON_TEST_ID =
    createTestIdForCoreInputTextElement("left-addon");

const CoreInputTextLeftAddon: FC<InputTextLeftAddonProps> = ({ children }) => {
    return children ? (
        <div
            className={classes["leftAddon"]}
            data-tsid={INPUT_TEXT_LEFT_ADDON_TEST_ID}
        >
            {children}
        </div>
    ) : null;
};

CoreInputTextLeftAddon.displayName =
    createDisplayNameForCoreInputTextElement("LeftAddon");

export default CoreInputTextLeftAddon;
